import { render } from "./Cloud.vue?vue&type=template&id=71bfceae"
import script from "./Cloud.vue?vue&type=script&lang=js"
export * from "./Cloud.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__